import { useEffect, useRef } from 'react';
import { ButtonClose } from '../Button-close/Button-close';
import './Error-alert.scss';

interface ErrorAlertProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}

export const ErrorAlert = ({
  isOpen,
  title,
  message,
  onClose,
  autoClose = true,
  duration = 6000,
}: ErrorAlertProps) => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (isOpen && autoClose) {
      timeoutRef.current = setTimeout(() => {
        onClose();
      }, duration);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isOpen, autoClose, duration, onClose]);

  if (!isOpen) return null;

  return (
    <div className="error-alert__overlay">
      <div className="error-alert__container">
        <div className="error-alert__content">
          <div className="error-alert__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="error-alert__text">
            <h4 className="error-alert__title">{title}</h4>
            <p className="error-alert__message">{message}</p>
          </div>
          <ButtonClose onClick={onClose} />
        </div>
        <div className="error-alert__progress">
          <div className="error-alert__progress-bar"></div>
        </div>
      </div>
    </div>
  );
};
